import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke061aRequest, Sgke061aResponse, Sgke061aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke061aService {

  /**
   * コンストラクタ
   * @param {Sgke061aService} sgke061aService
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibConfig
   * @memberof UsedSgke061aService
   */
  constructor(
    private service: Sgke061aService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * 初期表示API呼び出し
   * @param {Sgke061aRequest} request
   * @return {*}  {Observable<Sgke061aResponse>}
   * @memberof UsedSgke061aService
   */
  public doSgke061a(request: Sgke061aRequest): Observable<Sgke061aResponse> {

    return this.service.ke10RSGKE061APost(this.apiCommonService.setRequestCommon(request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックし、エラーの場合catchError()に処理が移る
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE061A');
          return throwError(err.message);
        })
      );
  }
}
